<template>
  <validation-observer 
    ref="refFormObserver" 
    mode="aggressive"
    :immediate="true"
    v-slot="{ invalid }">
    <b-form class="list-view product-checkout" @submit.prevent="onSubmit">
      <div>
        <!-- {{ products }} -->
        <!-- {{ selectedLocation }} -->
        <b-card title="Informationen">
          <b-row class="">
            <b-col sm="12" md="12" lg="6" xl="6">
              <b-form-group label="Gewerblich?" label-for="v-isOrganization">
                <b-form-checkbox
                  v-model="customer.isOrganization"
                  switch
                  inline
                >
                  <!-- {{ isCompany ? true : false }} -->
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="12" lg="6" xl="6" v-if="customer.isOrganization">
              <b-form-group label="Unternehmen" label-for="v-organizationName">
                <b-form-input
                  v-model="customer.organizationName"
                  placeholder="Unternehmensnamen eingeben"
                  :state="customer.organizationName ? true : false"
                />
                <small v-if="!customer.organizationName" class="text-danger">
                  (*) Pflichtfeld
                </small>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="">
            <b-col sm="12" md="12" lg="6" xl="6">
              <b-form-group label="Anrede" label-for="v-salutation">
                <v-select
                  id="v-salutation"
                  v-model="customer.salutation"
                  :clearable="false"
                  :options="getSalutionOptions()"
                  :state="customer.salutation ? true : false"
                />
                <small v-if="!customer.salutation" class="text-danger">(*) Pflichtfeld</small>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="">
            <b-col sm="12" md="12" lg="6" xl="6">
              <!-- Pflichtfeld-Anzeige für Vorname -->
              <b-form-group label="Vorname" label-for="v-firstname">
                <b-form-input
                  v-model="customer.firstName"
                  :state="customer.firstName ? true : false"
                />
                <small v-if="!customer.firstName" class="text-danger">(*) Pflichtfeld</small>
              </b-form-group>
            </b-col>

            <b-col sm="12" md="12" lg="6" xl="6">
              <b-form-group label="Nachname" label-for="v-lastname">
                <b-form-input
                  v-model="customer.lastName"
                  :state="customer.lastName ? true : false"
                />
                <small v-if="!customer.lastName" class="text-danger">(*) Pflichtfeld</small>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6" xl="6">
              <b-form-group label="Email" label-for="v-email">
                <b-form-input
                  v-model="customer.email"
                  :state="customer.email ? (isValidEmail(customer.email) ? true : false) : null"
                  type="email"
                  placeholder="ihre.email@beispiel.de"
                />
                <small v-if="!customer.email" class="text-danger">(*) Pflichtfeld</small>
                <small v-else-if="customer.email && !isValidEmail(customer.email)" class="text-danger">Bitte geben Sie eine gültige E-Mail-Adresse ein</small>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="12" lg="6" xl="6"
              ><b-form-group label="Telefon" label-for="phoneNumber">
                <b-form-input v-model="customer.phoneNumber" :state="customer.phoneNumber ? true : null" />
              </b-form-group></b-col
            >
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6" xl="6">
              <b-form-group label="Handy" label-for="mobile">
                <b-form-input 
                  v-model="customer.mobileNumber" 
                  :state="customer.mobileNumber ? (isValidMobileNumber(customer.mobileNumber) ? true : false) : null"
                  placeholder="z.B. +49 176 12345678 oder 0176 12345678"
                />
                <small v-if="!customer.mobileNumber" class="text-danger">(*) Pflichtfeld</small>
                <small v-else-if="customer.mobileNumber && !isValidMobileNumber(customer.mobileNumber)" class="text-danger">Bitte geben Sie eine gültige Mobilnummer ein</small>
                <small class="text-muted d-none d-md-inline"> Wird benötigt um Zugang zum Gelände zu ermöglichen.</small>
                <small class="text-muted d-md-none">Für Gelände-Zugang erforderlich</small>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <!-- Adresse -->
        <!--  -->
        <b-card title="Adresse">
          <b-row class="">
            <b-col sm="9" md="9" lg="10" xl="6">
              <b-form-group label="Strasse" label-for="">
                <b-form-input v-model="customer.street" :state="customer.street ? true : false" />
                <small v-if="!customer.street" class="text-danger">(*) Pflichtfeld</small>
              </b-form-group>
            </b-col>
            <b-col sm="3" md="3" lg="2" xl="2">
              <b-form-group label="Hausnummer" label-for="">
                <b-form-input v-model="customer.streetNumber" :state="customer.streetNumber ? true : false" />
                <small v-if="!customer.streetNumber" class="text-danger">(*) Pflichtfeld</small>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="">
            <b-col sm="3" md="3" lg="2" xl="2">
              <b-form-group label="PLZ" label-for="">
                <b-form-input 
                  v-model="customer.zipCode" 
                  :state="customer.zipCode ? (isValidZipCode(customer.zipCode) ? true : false) : null"
                  placeholder="z.B. 12345"
                  maxlength="5"
                />
                <small v-if="!customer.zipCode" class="text-danger">(*) Pflichtfeld</small>
                <small v-else-if="customer.zipCode && !isValidZipCode(customer.zipCode)" class="text-danger">Bitte geben Sie eine gültige deutsche PLZ ein</small>
              </b-form-group>
            </b-col>

            <b-col sm="9" md="9" lg="10" xl="6">
              <b-form-group label="Stadt" label-for="">
                <b-form-input v-model="customer.city" :state="customer.city ? true : false" />
                <small v-if="!customer.city" class="text-danger">(*) Pflichtfeld</small>
              </b-form-group>
            </b-col>

            <b-col sm="9" md="9" lg="6" xl="6">
              <b-form-group label="Land" label-for="">
                <v-select
                  id="v-country"
                  v-model="customer.country"
                  :clearable="false"
                  :options="getCountryOptions()"
                  :state="customer.country ? true : false"
                />
                <small v-if="!customer.country" class="text-danger">(*) Pflichtfeld</small>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <label for="textarea-default">Nachricht</label>
          <b-form-textarea
            id="textarea-default"
            v-model="customer.message"
            rows="3"
          />
        </b-card>
      </div>
      <!-- Right Col -->
      <div class="customer-card">
        <b-card>
          Füllen Sie bitte das Formular aus um eine Anfrage zu stellen.
          <hr />
          <h6 class="price-title">Details</h6>
          <ul class="list-unstyled">
            <li
              v-for="(product, index) in products"
              :key="index"
              class="price-detail"
            >
              <div class="detail-title">
                <p>{{ product.qty }} x {{ product.name }}</p>
              </div>
              <div class="detail-title">
                <p>{{ product.location }}</p>
              </div>
              <div class="detail-amt font-weight-bolder">
                <p>{{ product.price }}€</p>
              </div>
            </li>
          </ul>

          <!-- Rental terms, data protection notice and AGB checkbox moved outside the product loop -->
          <div class="mb-3">
            <p class="text-muted mb-2">
              Die monatliche Miete (inkl. 19% MwSt.) wird automatisch berechnet. Die Mindestmietdauer beträgt einen Monat. Der Vertrag verlängert sich jeweils um einen weiteren Monat, sofern er nicht bis 14 Tage vor Monatsende gekündigt wird.
            </p>
            <p class="text-muted mb-2">
              Ihre Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage verarbeitet. Weitere Informationen finden Sie in unserer Datenschutzerklärung.
            </p>
            <b-form-checkbox v-model="agbChecked">
              <p class="mb-0">
                Ich stimme den
                <a
                  target="_blank"
                  href="https://dateien.der-lagermeister.de/public/AGB.pdf"
                  >AGB</a
                >
                und
                <a
                  target="_blank"
                  href="https://dateien.der-lagermeister.de/public/DSGVO.pdf"
                  >Datenschutzbestimmungen zu.</a
                >
              </p>
            </b-form-checkbox>
          </div>

          <b-card-header class="flex-column align-items-start pb-0" />
          <b-card-text class="mb-0 pt-0 customer-info-text">
            {{ customer.organizationName }}
          </b-card-text>
          <b-card-text class="mb-0">
            {{ customer.salutation }} {{ customer.firstName }} {{ customer.lastName }}
          </b-card-text>
          <b-card-text class="mb-0">
            {{ customer.street }} {{ customer.streetNumber }}
          </b-card-text>
          <b-card-text class="mb-0">
            {{ customer.zipCode }} {{ customer.city }}
          </b-card-text>
          <b-card-text>{{ customer.country }}</b-card-text>
          <b-card-text v-if="customer.email" class="mb-0">
            <span class="text-muted">Email:</span> {{ customer.email }}
          </b-card-text>
          <b-card-text v-if="customer.phoneNumber" class="mb-0">
            <span class="text-muted"> Telefon:</span>
            {{ customer.phoneNumber }}
          </b-card-text>
          <b-card-text v-if="customer.mobileNumber" class="mb-0">
            <span class="text-muted">Mobil:</span> {{ customer.mobileNumber }}
          </b-card-text>

          <b-card-text>{{ customer.message }}</b-card-text>

          <!-- DEBUGGING OUTPUTS -->
          <!-- <div style="border: 1px solid red; padding: 10px; margin-bottom: 10px;">
            <p class="mb-0"><strong>Debug Info:</strong></p>
            <p class="mb-0">Observer `invalid` state: <strong>{{ invalid }}</strong></p>
            <p class="mb-0">AGB checked: <strong>{{ agbChecked }}</strong></p>
            <p class="mb-0">Button should be disabled: <strong>{{ invalid || !agbChecked }}</strong></p>
          </div> -->

          <!-- Development Mode Switch -->
          <div v-if="isDevelopment" class="mb-3">
            <b-form-group>
              <b-form-checkbox
                v-model="devModeApiDisabled"
                switch
              >
                <small class="text-muted">DEV: API-Aufruf deaktivieren (nur Spinner-Test)</small>
              </b-form-checkbox>
            </b-form-group>
            <div class="mb-2 d-flex justify-content-between align-items-center">
              <small class="text-info">
                <i class="feather icon-save"></i>
                Formulardaten werden automatisch gespeichert
              </small>
              <b-button
                size="sm"
                variant="outline-secondary"
                @click="clearAllPersistedData"
              >
                <i class="feather icon-trash-2"></i>
                Alle Daten löschen
              </b-button>
            </div>
          </div>
          
          <!-- Error Message Display -->
          <b-alert
            v-if="submissionError"
            variant="danger"
            show
            class="mb-3"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span>{{ submissionError }}</span>
              <b-button
                variant="outline-danger"
                size="sm"
                @click="retrySubmission"
                :disabled="isSubmitting"
              >
                Erneut versuchen
              </b-button>
            </div>
          </b-alert>
          
          <b-button
            type="submit"
            variant="primary"
            block
            :disabled="!formValid || !agbChecked || isSubmitting"
          >
            <span v-if="isSubmitting" class="d-flex align-items-center justify-content-center">
              <b-spinner small class="mr-2"></b-spinner>
              Wird gesendet...
            </span>
            <span v-else>Unverbindliche Mietanfrage senden</span>
          </b-button>
        </b-card>
      </div>
    </b-form>
    <b-modal
      id="modal-inquiry-checkout"
      ok-only
      ok-title="OK"
      modal-class="modal-primary"
      centered
      title="Danke!"
      @hidden="resetModal"
    >
      <b-card-text>
        Viele Dank für Ihre Anfrage. Wir prüfen die Verfügbarkeit der Container
        und melden uns schnellstmöglich bei Ihnen. <br />
        <br />
        Mit freundlichen Grüßen <br />
        Ihr Team von der-lagermeister.de
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-inquiry-error"
      :title="errorModalTitle"
      :modal-class="errorModalClass"
      centered
      :ok-title="errorModalOkTitle"
      :cancel-title="errorModalCancelTitle"
      :ok-only="!errorModalCanRetry"
      @ok="handleErrorModalOk"
      @cancel="handleErrorModalCancel"
      @hidden="handleErrorModalHidden"
    >
      <b-card-text>
        {{ errorModalMessage }}
      </b-card-text>
      <b-card-text v-if="errorModalDetails" class="mt-2">
        <small class="text-muted">{{ errorModalDetails }}</small>
      </b-card-text>
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BAlert,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormTextarea,
  BModal,
  BRow,
  BSpinner,
  VBModal,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import helper from '@/helper/helper'
import store from '@/store'
import { StatePersistence } from '@/utils/statePersistence'
import { ref } from '@vue/composition-api'

export default {
  components: {
    // BSV
    BAlert,
    BFormCheckbox,
    BForm,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BFormInvalidFeedback,
    BFormTextarea,
    BModal,
    BSpinner,

    // Form Validation
    ValidationProvider,
    ValidationObserver,

    // 3rd party
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    addressDetails: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { getFormattedDate, getCountryOptions, getSalutionOptions } = helper()

    const products = ref([])

    const fetchCartProducts = () => {
      products.value = store.getters.cart
    }

    fetchCartProducts()

    return {
      getFormattedDate,
      getCountryOptions,
      getSalutionOptions,
      products,
    }
  },

  data() {
    const isDevelopment = process.env.NODE_ENV === 'development'
    const savedFormData = StatePersistence.getCheckoutForm()
    
    // Merge saved data with defaults, preferring development test data in dev mode
    const defaultCustomer = {
      isOrganization: false,
      organizationName: isDevelopment ? '' : '',
      salutation: isDevelopment ? 'Herr' : '',
      firstName: isDevelopment ? 'Max' : '',
      lastName: isDevelopment ? 'Mustermann' : '',
      email: isDevelopment ? 'max@mustermann.de' : '',
      phoneNumber: isDevelopment ? '0123456789' : '',
      faxNumber: isDevelopment ? '0987654321' : '',
      mobileNumber: isDevelopment ? '0123456789' : '',
      street: isDevelopment ? 'Musterstrasse' : '',
      streetNumber: isDevelopment ? '1' : '',
      zipCode: isDevelopment ? '12345' : '',
      city: isDevelopment ? 'Musterstadt' : '',
      country: isDevelopment ? 'Deutschland' : '',
      message: isDevelopment ? 'Ich brauche ein Lager!' : '',
    }
    
    return {
      agbChecked: savedFormData?.agbChecked ?? isDevelopment,
      isSubmitting: false,
      submissionError: null,
      retryCount: 0,
      maxRetries: 3,
      isDevelopment,
      devModeApiDisabled: false,
      customer: savedFormData?.customer ? { ...defaultCustomer, ...savedFormData.customer } : defaultCustomer,
      // Error modal data
      errorModalTitle: '',
      errorModalMessage: '',
      errorModalDetails: '',
      errorModalClass: 'modal-danger',
      errorModalOkTitle: 'OK',
      errorModalCancelTitle: 'Abbrechen',
      errorModalCanRetry: false,
      currentError: null,
    }
  },

  watch: {
    // Watch for changes in customer data and save to localStorage
    customer: {
      handler(newCustomer) {
        if (!this.isDevelopment || Object.keys(newCustomer).some(key => newCustomer[key] !== '')) {
          this.saveFormData()
        }
      },
      deep: true,
      immediate: false
    },
    
    // Watch for AGB checkbox changes
    agbChecked(newValue) {
      this.saveFormData()
    }
  },

  computed: {
    selectedLocation() {
      return this.$store.getters.selectedLocation
    },
    formValid() {
      return (
        (!this.customer.isOrganization || this.customer.organizationName) &&
        this.customer.salutation &&
        this.customer.firstName &&
        this.customer.lastName &&
        this.isValidEmail(this.customer.email) &&
        this.isValidMobileNumber(this.customer.mobileNumber) &&
        this.customer.street &&
        this.customer.streetNumber &&
        this.isValidZipCode(this.customer.zipCode) &&
        this.customer.city &&
        this.customer.country
      )
    }
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.refFormObserver) {
        this.$refs.refFormObserver.validate().then(() => {
          // Diese Zeile ist optional, kann aber beim Debuggen helfen, um zu sehen, ob die Validierung durchläuft
          // console.log('Initial validation triggered in mounted via $nextTick');
        });
      } else {
        console.error('refFormObserver is not available in mounted hook.');
      }
    });
  },

  methods: {
    showModalSuccessInquiry() {
      this.$bvModal.show('modal-inquiry-checkout')
    },

    showErrorModal(title, message, details = '', canRetry = false, modalClass = 'modal-danger') {
      this.errorModalTitle = title
      this.errorModalMessage = message
      this.errorModalDetails = details
      this.errorModalCanRetry = canRetry
      this.errorModalClass = modalClass
      this.errorModalOkTitle = canRetry ? 'Erneut versuchen' : 'OK'
      this.errorModalCancelTitle = 'Abbrechen'
      this.$bvModal.show('modal-inquiry-error')
    },

    handleErrorModalOk() {
      if (this.errorModalCanRetry) {
        this.sendInquiryRequest()
      }
    },

    handleErrorModalCancel() {
      this.retryCount = 0
    },

    handleErrorModalHidden() {
      this.currentError = null
    },

    resetModal() {
      this.$store.dispatch('cleanCart')
      this.$router.push({ name: 'lagermeister-shop' })
    },

    async sendInquiryRequest() {
      if (this.isSubmitting) return
      
      this.isSubmitting = true
      this.submissionError = null
      
      try {
        // Development mode: Skip API call if disabled
        if (this.isDevelopment && this.devModeApiDisabled) {
          console.log('DEV MODE: API call skipped - simulating successful submission')
          // Simulate network delay
          await new Promise(resolve => setTimeout(resolve, 2000))
          
          console.log('Inquiry simulation completed successfully')
          this.retryCount = 0
          this.clearFormData() // Clear saved form data on success
          this.showModalSuccessInquiry()
        } else {
          // Normal API call
          const inquiry = this.generateInquiryMapping()
          await this.$store.dispatch('addInquiry', inquiry)
          
          console.log('Inquiry created successfully')
          this.retryCount = 0
          this.clearFormData() // Clear saved form data on success
          this.showModalSuccessInquiry()
        }
      } catch (error) {
        console.error('Error creating inquiry:', error)
        this.handleSubmissionError(error)
      } finally {
        this.isSubmitting = false
      }
    },

    handleSubmissionError(error) {
      this.retryCount++
      this.currentError = error
      
      let errorTitle = 'Fehler'
      let errorMessage = 'Es ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
      let errorDetails = ''
      let modalClass = 'modal-danger'
      const canRetry = this.retryCount < this.maxRetries
      
      if (!error?.response && (error?.code === 'ECONNABORTED' || error?.message?.includes('timeout'))) {
        errorTitle = 'Zeitüberschreitung'
        errorMessage = 'Die Anfrage hat zu lange gedauert. Der Server antwortet möglicherweise nicht.'
        errorDetails = 'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.'
      } else if (!error?.response && (error?.code === 'NETWORK_ERROR' || error?.message?.includes('Network'))) {
        errorTitle = 'Verbindungsfehler'
        errorMessage = 'Es konnte keine Verbindung zum Server hergestellt werden.'
        errorDetails = 'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.'
      } else if (error?.response?.status === 400) {
        errorTitle = 'Ungültige Anfrage'
        errorMessage = 'Die übermittelten Daten sind ungültig.'
        errorDetails = 'Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.'
        modalClass = 'modal-warning'
      } else if (error?.response?.status === 401) {
        errorTitle = 'Authentifizierung erforderlich'
        errorMessage = 'Sie müssen sich anmelden, um diese Aktion durchzuführen.'
        errorDetails = 'Bitte melden Sie sich an und versuchen Sie es erneut.'
      } else if (error?.response?.status === 403) {
        errorTitle = 'Zugriff verweigert'
        errorMessage = 'Sie haben keine Berechtigung für diese Aktion.'
        errorDetails = 'Bitte kontaktieren Sie den Support, falls Sie Hilfe benötigen.'
      } else if (error?.response?.status === 404) {
        errorTitle = 'Service nicht verfügbar'
        errorMessage = 'Der angeforderte Service konnte nicht gefunden werden.'
        errorDetails = 'Der Service ist möglicherweise vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.'
      } else if (error?.response?.status === 422) {
        errorTitle = 'Validierungsfehler'
        errorMessage = 'Einige Ihrer Eingaben sind ungültig.'
        // Extract validation errors if available
        if (error.response?.data?.errors) {
          const errors = error.response.data.errors
          const errorList = Object.keys(errors).map(field => {
            const fieldName = this.getFieldNameInGerman(field)
            return `${fieldName}: ${errors[field].join(', ')}`
          })
          errorDetails = errorList.join('\n')
        } else {
          errorDetails = 'Bitte überprüfen Sie alle Pflichtfelder und versuchen Sie es erneut.'
        }
        modalClass = 'modal-warning'
      } else if (error?.response?.status === 429) {
        errorTitle = 'Zu viele Anfragen'
        errorMessage = 'Sie haben zu viele Anfragen in kurzer Zeit gesendet.'
        errorDetails = 'Bitte warten Sie einen Moment und versuchen Sie es dann erneut.'
      } else if (error?.response?.status === 500) {
        errorTitle = 'Serverfehler'
        errorMessage = 'Ein interner Serverfehler ist aufgetreten.'
        errorDetails = 'Wir entschuldigen uns für die Unannehmlichkeiten. Unser Team wurde benachrichtigt. Bitte versuchen Sie es später erneut.'
      } else if (error?.response?.status === 502 || error?.response?.status === 503) {
        errorTitle = 'Service vorübergehend nicht verfügbar'
        errorMessage = 'Der Service ist momentan nicht erreichbar.'
        errorDetails = 'Bitte versuchen Sie es in wenigen Minuten erneut.'
      }
      
      this.submissionError = errorMessage
      
      if (!canRetry) {
        errorDetails = (errorDetails ? errorDetails + '\n\n' : '') + 
          `Maximale Anzahl von Versuchen (${this.maxRetries}) erreicht. ` +
          'Bitte kontaktieren Sie unseren Support unter support@der-lagermeister.de, falls das Problem weiterhin besteht.'
      } else {
        errorDetails = (errorDetails ? errorDetails + '\n\n' : '') + 
          `Versuch ${this.retryCount} von ${this.maxRetries}`
      }
      
      this.showErrorModal(errorTitle, errorMessage, errorDetails, canRetry, modalClass)
    },

    getFieldNameInGerman(field) {
      const fieldMap = {
        'firstName': 'Vorname',
        'lastName': 'Nachname',
        'email': 'E-Mail',
        'phoneNumber': 'Telefonnummer',
        'mobileNumber': 'Handynummer',
        'street': 'Straße',
        'streetNumber': 'Hausnummer',
        'zipCode': 'Postleitzahl',
        'city': 'Stadt',
        'country': 'Land',
        'organizationName': 'Unternehmen',
        'salutation': 'Anrede',
        'message': 'Nachricht'
      }
      return fieldMap[field] || field
    },
    
    retrySubmission() {
      this.submissionError = null
      this.sendInquiryRequest()
    },

    generateInquiryMapping() {
      const storageJSON = {
        storage: this.products.map(storage => ({
          id: storage.storage_type,
          type: storage.name,
          location: this.selectedLocation.id,
          priceStorage: storage.price,
          numberStorage: storage.qty,
          estimatedEndRent: storage.estimatedEndRent,
          estimatedStartRent: storage.estimatedStartRent,
        })),
      }

      const inquiry = {
        salutation: this.customer.salutation,
        firstName: this.customer.firstName,
        lastName: this.customer.lastName,
        email: this.customer.email,
        phoneNumber: this.customer.phoneNumber,
        mobileNumber: this.customer.mobileNumber,
        street: this.customer.street,
        streetNumber: this.customer.streetNumber,
        zipCode: this.customer.zipCode,
        city: this.customer.city,
        country: this.customer.country,
        message: this.customer.message,
        isOrganization: this.customer.isOrganization,
        organizationName: this.customer.organizationName,
        created_by: 'shop',
        status: 'open',
        offers: [],
        storageLocation: String(this.selectedLocation.id),
        leadSource: 'Shop',
        storageJSON,
      }

      return inquiry
    },

    // Validation methods with input sanitization
    isValidEmail(email) {
      if (!email) return false
      const sanitizedEmail = email.trim().toLowerCase()
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(sanitizedEmail)
    },

    isValidMobileNumber(mobile) {
      if (!mobile) return false
      const cleanedMobile = mobile.replace(/\s/g, '')
      const mobileRegex = /^[+]?[0-9\s\-\(\)]{10,}$/
      return mobileRegex.test(cleanedMobile)
    },

    isValidZipCode(zipCode) {
      if (!zipCode) return false
      const cleanedZip = zipCode.trim()
      const zipRegex = /^\d{5}$/
      return zipRegex.test(cleanedZip)
    },

    sanitizeInput(input) {
      if (typeof input !== 'string') return input
      return input.trim().replace(/[<>]/g, '')
    },
    async onSubmit() {
      if (this.isSubmitting) return
      
      const valid = await this.$refs.refFormObserver.validate()
      
      if (valid && this.agbChecked) {
        // Sanitize inputs before submission
        Object.keys(this.customer).forEach(key => {
          if (typeof this.customer[key] === 'string') {
            this.customer[key] = this.sanitizeInput(this.customer[key])
          }
        })
        
        this.sendInquiryRequest()
      } else {
        if (!this.agbChecked && valid) {
          this.showErrorModal(
            'AGB-Zustimmung erforderlich',
            'Bitte akzeptieren Sie die AGB und Datenschutzbestimmungen.',
            'Die Zustimmung zu unseren Geschäftsbedingungen ist für die Bearbeitung Ihrer Anfrage erforderlich.',
            false,
            'modal-warning'
          )
        } else {
          this.showErrorModal(
            'Formular unvollständig',
            'Bitte füllen Sie alle Pflichtfelder korrekt aus.',
            'Überprüfen Sie, ob alle mit (*) markierten Felder ausgefüllt sind und die AGB akzeptiert wurden.',
            false,
            'modal-warning'
          )
        }
      }
    },

    // Save form data to localStorage
    saveFormData() {
      if (this.isSubmitting) return // Don't save during submission
      
      const formData = {
        customer: this.customer,
        agbChecked: this.agbChecked,
        timestamp: Date.now()
      }
      
      StatePersistence.saveCheckoutForm(formData)
    },

    // Clear saved form data after successful submission
    clearFormData() {
      StatePersistence.remove('lms_checkout_form')
    },

    // Restore form data from storage
    restoreFormData() {
      const savedData = StatePersistence.getCheckoutForm()
      if (savedData) {
        this.customer = { ...this.customer, ...savedData.customer }
        this.agbChecked = savedData.agbChecked
      }
    },

    // Clear all persisted data (for development)
    clearAllPersistedData() {
      StatePersistence.clearAll()
      // Show simple confirmation modal
      this.showErrorModal(
        'Daten gelöscht',
        'Alle gespeicherten Formulardaten wurden erfolgreich gelöscht.',
        'Die Seite wird neu geladen...',
        false,
        'modal-info'
      )
      // Reload the page to see the cleared state
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    }
  },

  // Clear form data on successful submission
  beforeDestroy() {
    // Save current form state before leaving (in case user navigates away)
    this.saveFormData()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.customer-info-text {
  padding-top: 0 !important;
  margin-top: 0 !important;
}

.card-header.pb-0 {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}

.card-body {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
</style>
